import {Injectable} from '@angular/core';

// eslint-disable-next-line @typescript-eslint/ban-types
declare const gtag: Function;

export const USER_TYPE_MANAGER = 'manager' as const;

export const GaKeyEvent = {
    SignUpManager: 'sign_up_manager',
} as const;

@Injectable({
    providedIn: 'root',
})
export class GoogleAnalyticsService {
    /**
     * Push a GA4 event with manager user_type on every call.
     */
    trackEvent(eventName: string, params: Record<string, string | number | boolean | undefined> = {}): void {
        if (typeof gtag !== 'function') {
            return;
        }

        gtag('event', eventName, {
            user_type: USER_TYPE_MANAGER,
            ...params,
        });
    }

    /**
     * Manager portal signup conversion event.
     */
    trackSignUp(method = 'email'): void {
        this.trackEvent(GaKeyEvent.SignUpManager, {
            method,
        });
    }

    /**
     * Identify the logged-in manager for GA4 (cross-surface stitching, web ↔ app).
     * Uses the opaque manager/user ID — never email or name.
     */
    setAnalyticsUser(userId: string | number | undefined): void {
        if (typeof gtag !== 'function' || !userId) {
            return;
        }

        // `user_id_{userId}` is the shared GA4 identity format across the tenant
        // portal, manager portal, and backend events, so the same person is stitched
        // into one GA4 user regardless of surface.
        gtag('set', {user_id: `user_id_${userId}`});
        gtag('set', 'user_properties', {user_type: USER_TYPE_MANAGER});
    }

    /**
     * Clear the GA4 user identity, e.g. on logout.
     */
    clearAnalyticsUser(): void {
        if (typeof gtag !== 'function') {
            return;
        }

        gtag('set', {user_id: undefined});
        gtag('set', 'user_properties', {user_type: undefined});
    }
}
